module.exports = __webpack_public_path__ + "img/emp3-1.551851cf.jpg";